import React from "react";
import { Row, Col, Layout, message } from "antd";
import { connect } from "react-redux";
import get from "lodash/get";

import { consentServices } from "../../services";
import classes from "./Consent.css";
import ConsentForm from "../../components/Consent/ConsentSteps";

import { consentUpdate } from "../../reducers/consent/actions";
import { Helmet } from "react-helmet";

import isAuthenticated from "../../utils/isAuthenticated";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router";
import { withParams } from "../../utils/url";

const routes = require("../../routes.json");

const { Content } = Layout;

class ConsentComponent extends React.Component {
  constructor(props) {
    super(props);

    const queryParams = new URLSearchParams(this.props.location.search);

    this.state = {
      currentStep: "Step 1",
      currentStepInt: 1,
      subjectID: queryParams.get("subjectID") || "",
      siteID: queryParams.get("site") || "",
    };
  }

  handleNext = () => {
    let { currentStep } = this.state;

    const queryParams = new URLSearchParams(this.props.location.search);

    if (currentStep === "Step 1") {
      this.setState({
        loading: true,
      });

      consentServices.create(this.state).then(
        (response) => {
          const consentResponse = response.data;

          if (get(consentResponse, "consent_workflow_type") === "lhs") {
            this.props.consentUpdate({
              ...consentResponse,
              consentRandomization: this.props.consentRandomization,
              siteID: this.state.siteID,
              userID: this.state.userID,
              password: this.state.password,
            });
            this.props.history.push(
              queryParams.get("obtainConsent") === "true"
                ? withParams(routes.admin.consentTypeLhs, {
                    obtainConsent: "true",
                  })
                : routes.admin.consentTypeLhs
            );
          } else if (get(consentResponse, "consent_workflow_type") === "mevo") {
            this.props.consentUpdate({
              ...consentResponse,
              consentRandomization: this.props.consentRandomization,
              siteID: this.state.siteID,
              userID: this.state.userID,
              password: this.state.password,
            });

            this.props.history.push(
              queryParams.get("obtainConsent") === "true"
                ? withParams(routes.admin.consentTypeMevo, {
                    obtainConsent: "true",
                  })
                : routes.admin.consentTypeMevo
            );
          } else if (get(consentResponse, "consent_workflow_type") === "mevo_v2") {
            this.props.consentUpdate({
              ...consentResponse,
              consentRandomization: this.props.consentRandomization,
              siteID: this.state.siteID,
              userID: this.state.userID,
              password: this.state.password,
            });

            this.props.history.push(
              queryParams.get("obtainConsent") === "true"
                ? withParams(routes.admin.consentTypeMevoV2, {
                    obtainConsent: "true",
                  })
                : routes.admin.consentTypeMevoV2
            );
          }
        },
        (error) => {
          if (error.response) {
            const errors = error.response.data.errors;
            const e = error.response.data.error;
            if (errors) {
              message.config({ style: { color: "#424242" } });
              message.error(JSON.stringify(errors), 5);
            }
            if (e) {
              message.config({ style: { color: "#424242" } });
              message.error(JSON.stringify(e), 5);
            }
          }

          this.setState({
            currentStep: "Step 1",
            currentStepInt: 1,
          });
        }
      );
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { loading } = this.state;

    return (
      <div>
        <Helmet>
          <title>
            {this.props.i18n.t("NamespaceConsent:Trial Management Portal")}:{" "}
            {this.props.i18n.t("NamespaceConsent:Consent")}
          </title>
        </Helmet>
        <div className={classes.parentContainer}>
          <Layout className={classes.parentContainer}>
            <Content className={classes.content}>
              <Row>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 20, offset: 2 }}
                  md={{ span: 16, offset: 4 }}
                  style={{ paddingTop: "4rem" }}
                >
                  <ConsentForm
                    consentRandomization={this.props.consentRandomization}
                    loading={loading}
                    {...this.state}
                    handleNext={this.handleNext}
                    handleChange={this.handleChange}
                  />
                </Col>
              </Row>
            </Content>
          </Layout>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { consentUpdate };

export default isAuthenticated(
  connect(
    () => ({}),
    mapDispatchToProps
  )(withRouter(withNamespaces()(ConsentComponent)))
);



// WEBPACK FOOTER //
// ./src/containers/Consent/Consent.js